import React, { useEffect } from 'react';
import emailjs from 'emailjs-com';
import logo from '../../images/contact-removebg-preview.png'
import Aos from 'aos';
import 'aos/dist/aos.css';

const Contact = () => {
    useEffect(() => {
        Aos.init()
    })

    const sendEmail = (e) => {
        e.preventDefault();
    
        emailjs.sendForm('service_uojygfa', 'gmail_setup11', e.target, 'user_tyOoUZG9yAFbPMAqBF22r')
          .then((result) => {
              console.log(result.text);
          }, (error) => {
              console.log(error.text);
          });
          e.target.reset()
        };


    return (
        <div className="bg-gray-300 pb-10 ">
            <h1 className="text-4xl font-bold text-blue-500 mb-10">Get In Touch</h1>
            <div className="grid lg:grid-cols-3 mt-3">
            <div className="text-2xl text-red-700"
            data-aos-duration="3000"
            data-aos="flip-right">
                <i class="fas fa-phone-alt"></i>
                <p> <span className="font-bold text-3xl">Call Me</span> <br />+8801968047622</p>
            </div>
            <div className="text-2xl text-red-700"
            data-aos-duration="3000"
            data-aos="flip-right"
            >
                <i class="fas fa-map-marker-alt "></i>
           <p> <span className="font-bold text-3xl">Location</span> <br />Jeshore-7620,Khulna</p>
            </div>
            <div className="text-2xl text-red-700"
            data-aos-duration="3000"
            data-aos="flip-right"
            >
                <i class="fas fa-envelope"></i>
            <p> <span className="font-bold text-3xl">Email </span> <br /> joy10311@gmail.com</p>
            </div>
            </div>

            <div
             data-aos="fade-up"
             data-aos-duration="3000"
            className="grid lg:grid-cols-2 px-20">
            <div
            data-aos="flip-left"
            data-aos-easing="ease-out-cubic"
            data-aos-duration="2000"
            className="mt-20 lg:rounded-xl lg:shadow-2xl lg:mr-5 lg:pl-20 pt-10 ">
                <h1 className="lg:text-justify text-xl font-semibold mb-5">I'd Love to hear from you. Whether you have <br /> a  question or just want to say Hi, feel free to <br /> drop a message. I'll try my best to get back to you!</h1>
                <form onSubmit={sendEmail}>
                
                <input className="border border-red-800 pt-2 pb-2 lg:pl-40 block " type="text" name="name" id="" placeholder="Name" />
                <input className="border border-gray-800 pt-2 pb-2 lg:pl-40 block my-5" type="email" name="email" id="" placeholder="Email" />
                <input className="border border-gray-800 mt-2 pt-14 lg:pl-40 pb-14 block" type="text" name="message" id="" placeholder="Enter your message" />
                       <input className="border border-gray-800 px-3 py-3 mb-3 bg-blue-700 text-white rounded-lg block mt-5" type="submit" value="Send Message" />
                        
                </form>
            </div>
            <div data-aos="fade-up"
             data-aos-duration="3000">
                <img className="h-100" src={logo} alt="" />
            </div>
            </div>
        </div>
    );
};

export default Contact;
